import { format } from "date-fns";
import { Page } from "@/components/layout";
import { useAuth } from "@/hooks/useAuth";
import { useSystemAdmin } from "@/hooks/useSystemAdmin";
import { PERSONA_LABELS, deriveWorkspacePersona } from "@/config/workspacePersona";
import { ContentCard } from "@/components/ui/ContentCard";
import { ProfileField, ProfileNameForm } from "@/components/pages/profile";

/**
 * AE-207 manage-profile screen. Name is the only field the user controls; email, role,
 * school and district are administered elsewhere and render with the shared locked hint.
 */
export const ProfilePage = () => {
  const { userData } = useAuth();
  const { isSystemAdmin } = useSystemAdmin();

  const roleLabel = PERSONA_LABELS[deriveWorkspacePersona(userData)];
  const school = userData?.custom_school_name || userData?.school_name;
  const district = userData?.custom_district_name || userData?.district_name;
  const memberSince = userData?.created_at ? format(new Date(userData.created_at), "MMMM d, yyyy") : null;

  return (
    <Page.Container className="animate-fade-in">
      <Page.Header>
        <h1 className="font-literata text-3xl font-semibold text-white">Profile</h1>
        <p className="font-inter text-sm text-white/75">
          Your account details. Update your name here; everything else is managed by your district.
        </p>
      </Page.Header>

      <Page.Content>
        <ContentCard className="max-w-2xl space-y-4">
          <ProfileNameForm
            firstName={userData?.first_name}
            lastName={userData?.last_name}
            userName={userData?.user_name}
          />
          <ProfileField label="Email" value={userData?.email} locked />
          <ProfileField label="Role" value={roleLabel} badge={isSystemAdmin ? "Superadmin" : undefined} locked />
          <ProfileField label="School" value={school} locked />
          <ProfileField label="District" value={district} locked />
          <ProfileField label="Member since" value={memberSince} />
        </ContentCard>
      </Page.Content>
    </Page.Container>
  );
};
